import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { Tooltip } from '@mui/material';
import { BorderlessTooltipProps } from '../../../../../../../constants/styles';

export const PENDING_TRANSACTIONS_TOOLTIP =
  'This company has pending transactions impacting one or more metrics';

interface PendingTransactionsIndicatorProps {
  hasPendingTransactionImpact: boolean | undefined;
}

export function PendingTransactionsIndicator({
  hasPendingTransactionImpact,
}: PendingTransactionsIndicatorProps) {
  if (!hasPendingTransactionImpact) {
    return null;
  }

  return (
    <Tooltip {...BorderlessTooltipProps} title={PENDING_TRANSACTIONS_TOOLTIP} placement='top'>
      <HourglassEmptyIcon
        fontSize='small'
        aria-label='Pending transactions indicator'
        sx={{ color: (theme) => theme.palette.warning.main }}
      />
    </Tooltip>
  );
}
